import React from "react"
import { Link, graphql } from "gatsby"

import AboutText from "../components/about-text"
import Skills from "../components/skills"
import Header from "../components/header"
import SEO from "../components/seo"

import "./home.css"
import Footer from "../components/footer"
import me from "../images/me.jpg" // Tell webpack this JS file uses this image

const Home = ({
  data: {
    allMarkdownRemark: { edges },
  },
}) => (
  <>
    <SEO title="Home" />
    <Header hideOnMobile={false} />

    <section className="hero">
      <div className="container">
        <img src={me} />
        <h1>Steve Baker</h1>
        <h3 className="text-muted" hidden>
          <em>
            Merseyside, England
          </em>
        </h3>
        <h3>Senior Full Stack .NET Developer | Remote | Azure, JavaScript, CI/CD</h3>
      </div>
      <div className="container">
        <AboutText />
        <h2>Technologies</h2>
        <Skills />
      </div>
    </section>

    <section className="home-posts" hidden>
      <h2>Recent Articles</h2>

      <div className="container">
        {edges.map(({ node: post }) => (
          <div className="post" key={post.id}>
            <Link to={getPostLink(post)} >{post.frontmatter.title}</Link>
            <div className="post-meta text-muted"><em>{post.frontmatter.date}</em></div>
            {/* <p>{post.excerpt}</p> */}
          </div>
        ))}
      </div>


      <Link className="" to="/blog">
        <h4>
          View all articles &#62;
        </h4>
      </Link>
    </section>

    <Footer></Footer>
  </>
)

const getPostLink = node => {
  const path = node.frontmatter.permalink
  return "/blog" + path
}

export default Home

export const pageQuery = graphql`
  query {
    allMarkdownRemark(
      limit: 2
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 200)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            permalink
            title
          }
        }
      }
    }
  }
`
